const mabaniNavLinks = [
  {
    label: "The Investigation",
    to: "/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe",
  },
  {
    label: "Key Locations",
    to: "/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/locations",
  },
  {
    label: "Behind the Reporting",
    to: "/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/behind-the-reporting",
  },
  {
    label: "Subsequent Coverage",
    to: "/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/subsequent-coverage",
  },
  {
    label: "Documentary",
    to: "/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/documentary",
  },
  {
    label: "Artistic Renderings",
    to: "/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/artistic-renderings",
  },
  {
    label: "Published Globally",
    to: "/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/global",
  },
  {
    label: "Awards",
    to: "/investigations/the-secretive-libyan-prisons-that-keep-migrants-out-of-europe/awards",
  }
];

export default mabaniNavLinks;